import * as React from 'react';
import { Grid } from '@mui/material';
import { ReceiptBatchOverview } from './ReceiptBatchOverview';

import type { JSX } from 'react';

interface ReceiptBatchCommonViewProps {
  receiptsCount: number;
  totalAmount: number;
  totalAdditionalFeeAmount: number;
  totalIncludedFeeAmount: number;
  ReceiptBatchCommonForm: React.ReactNode;
  ReceiptBatchImageInput: React.ReactNode;
  CashLink: React.ReactNode;
}

export function ReceiptBatchV2CommonView({
  ReceiptBatchCommonForm,
  receiptsCount,
  totalAmount,
  totalAdditionalFeeAmount,
  totalIncludedFeeAmount,
  ReceiptBatchImageInput,
  CashLink,
}: ReceiptBatchCommonViewProps): JSX.Element {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        alignItems: 'flex-start',
      }}
    >
      {ReceiptBatchCommonForm}
      <ReceiptBatchOverview
        receiptsCount={receiptsCount}
        totalAmount={totalAmount}
        totalAdditionalFeeAmount={totalAdditionalFeeAmount}
        ReceiptBatchImageInput={ReceiptBatchImageInput}
      />
      {CashLink}
    </Grid>
  );
}
